import { setUser as setSentryUser } from '@sentry/react'
import Parse from 'parse'
import {
  analyticsDisableEmailMarketing,
  analyticsUnsetUserEmail,
  analyticsUnsetUserId,
  analyticsUnsetUserPhone
} from '../analytics/actions'
import { clearPasswordlessLoginError } from '../../client/login/passwordlessLoginState'
import { updateIntercomUser } from '../../client/app/intercom'
import { clearLastVisitedItems } from '../marketLanding/lastVisitedItems'
import { refetchCurrentUser, resetCurrentUserCache } from './currentApolloUser'
import { _setCurrentUser } from './currentUser'

/**
 * Logs the current user out and updates state accordingly.
 */

export const logoutCurrentUser = async () => {
  await Parse.User.logOut()
  _setCurrentUser(null)
  resetCurrentUserCache()
  clearLastVisitedItems()

  // https://support.google.com/tagmanager/answer/4565987?hl=en
  // The Google Analytics User ID policy requires that you stop any measurement
  // based on the user ID once the user signs out of your website.
  analyticsUnsetUserId()
  analyticsUnsetUserEmail()
  analyticsUnsetUserPhone()
  analyticsDisableEmailMarketing()
  setSentryUser(null)
  updateIntercomUser()
}
/**
 * Keep the current user object up to date after logging in or signing up.
 * @param {string} sessionToken
 */

export const becomeUser = async (sessionToken) => {
  const parseUser = await Parse.User.become(sessionToken)
  return setCurrentUser(parseUser)
}
/**
 * Sets the current user, this is for usages when we update the user object somehow.
 * Login and signup should use `becomeUser` instead.
 * @param {Parse.User<Parse.Attributes>} parseUser
 */

export const setCurrentUser = async (parseUser) => {
  _setCurrentUser(parseUser)
  clearPasswordlessLoginError()
  await refetchCurrentUser()
  updateIntercomUser()
  return parseUser
}
